import { IGoalStreakInfoDTO } from "motw_core/DTOs/GoalStreakInfo/IGoalStreakInfoDTO";
import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { DailyGoal } from "./DailyGoal/DailyGoal";

export function RenderDailyGoal({
    ToggleCheckbox,
    isChecked,
    goal,
    goalStreakInfo,
    showFutureDailyGoals,
}: {
    ToggleCheckbox(goalName: string): void;
    isChecked: boolean;
    goal: IGoal;
    goalStreakInfo?: IGoalStreakInfoDTO;
    showFutureDailyGoals: boolean;
}) {
    if (!goalStreakInfo) {
        return null;
    }

    const shouldShow =
        (showFutureDailyGoals && goalStreakInfo.isFutureDailyGoal) ||
        !goalStreakInfo.isFutureDailyGoal;

    if (!shouldShow) {
        return null;
    }

    const latestDatapointTime = goalStreakInfo
        ? goalStreakInfo.result_streakenddate
        : undefined;

    return (
        <DailyGoal
            goal={goal}
            onCheck={() => ToggleCheckbox(goal.name)}
            isChecked={isChecked}
            latestDatapointTime={latestDatapointTime}
            goalStreakInfo={goalStreakInfo}
        />
    );
}
